import apolloClient from 'services/apollo-client';
import useFetchSurfaceNodesFromCache from 'components/canvas/hooks/use-fetch-surface-nodes-from-cache';
import { surfaceNodesQuery } from 'graphql/surface-node/queries/surface-nodes';
import { set } from 'lodash/fp';
import { SurfaceNodeUnion } from 'graphql/types';
import { get } from 'lodash';

function fetchLatestNodeStateFromCache(
  node?: SurfaceNodeUnion | null,
): SurfaceNodeUnion | null | undefined {
  if (node) {
    return get(
      apolloClient.cache,
      `data.data.${node.__typename}:` + node.id,
      undefined,
    );
  }

  return node;
}

export function useSetHighestZIndexToNode(): (node: SurfaceNodeUnion) => void {
  return function setHighestZIndexToNode(node: SurfaceNodeUnion) {
    const surface = node?.surface?.id;

    // Get the key of node that has to be top
    // Place the node on first list on

    const latestNodeState = fetchLatestNodeStateFromCache(node) ?? node;

    const variables = {
      input: { filter: { surface } },
    };

    const { surfaceNodes } = apolloClient.readQuery<any>({
      query: surfaceNodesQuery,
      variables,
    });

    const filteredSurfaceNodes = surfaceNodes?.nodes?.filter(
      ({ id }) => id !== node.id,
    );

    const newSurfaceNodes = [...filteredSurfaceNodes, node];

    apolloClient.writeQuery({
      query: surfaceNodesQuery,
      data: {
        surfaceNodes: set('nodes', newSurfaceNodes, surfaceNodes),
      },
      variables,
    });
  };
}

export default useFetchSurfaceNodesFromCache;
